<template>

  <div>
    <div class="video_appbox show" v-show="video_show">
        <div class="video_t" id="player1"><video width="1035" height="511" src="https://www.ruijienetworks.com/solutions/smb/auto-configured-Network-Solution/video/WhatisaAuto-configuredNetwork(ACN)Solution.mp4" type="video/mp4" id="media" poster="undefined" controls="controls" preload="none" autoplay="autoplay"></video></div>
        <div class="mask"></div>
        <div class="vide0_close" @click="closeVideo"><i class="icon-cuo">X</i></div>
    </div>
    <div class="site_banner_wrap">
            <div class="site_banner bg-cover">
                <img src="https://www.ruijienetworks.com/solutions/smb/auto-configured-Network-Solution/image/acn-banner1banner.png">
                <div class="site_banner_text v-m-c">
                    <div class="wrap">
                        <div class="banner_le">
                            <h2 class="fnt_48 wow fadeInDown animated animated" style="visibility: visible; animation-name: fadeInDown;">Simplify IT, Free Hands</h2>
                            <p class="fnt_20 wow fadeInUp animated animated animated" style="visibility: visible; animation-name: fadeInUp;">Auto-configured Network(ACN) Solution</p>
                            <div class="fnt_18 wow fadeInRight bannerbtn video_button animated animated" data-video="https://www.ruijienetworks.com/solutions/smb/auto-configured-Network-Solution/video/WhatisaAuto-configuredNetwork(ACN)Solution.mp4" style="visibility: visible; animation-name: fadeInRight;" @click="showVideo">
                                Learn More <i class="iconfont icon-a-youjiantouzhixiangyoujiantou"></i>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
    </div>
    <div class="index_01">
            <div class="wrap">
                <h2 class="title fnt_32 wow fadeInUp animated animated" style="visibility: visible; animation-name: fadeInUp;">Current Challenges</h2>
                <ul class="clearfix">
                    <li class="pull-left wow fadeInUp animated animated" style="visibility: visible; animation-name: fadeInUp;">
                        <img src="https://www.ruijienetworks.com/solutions/smb/auto-configured-Network-Solution/image/icon11list1.png" alt="">
                        <div>
                            <h2 class="fnt_18">Multi-Services Mixed</h2>
                            <p class="">
                                With the rapid growth of multiple services in
                                <br>
                                enterprise networks, multi-VLAN design is required to
                                <br>
                                adapt to this change.
                            </p>
                        </div>
                    </li>
                    <li class="pull-left wow fadeInUp animated animated" style="visibility: visible; animation-name: fadeInUp;">
                          <img src="https://www.ruijienetworks.com/solutions/smb/auto-configured-Network-Solution/image/icon11list1.png" alt="">
                        <div>
                            <h2 class="fnt_18">Complex Deployment</h2>
                            <p class="">
                                Traditional networks need to be configured device by
                                <br>
                                device, from WAN to wireless, costing time and
                                <br>
                                resources.
                            </p>
                        </div>
                    </li>
                    <li class="pull-left wow fadeInUp animated animated" style="visibility: visible;">
                         <img src="https://www.ruijienetworks.com/solutions/smb/auto-configured-Network-Solution/image/icon11list1.png" alt="">
                        <div>
                            <h2 class="fnt_18">High Technical Skills</h2>
                            <p class="">
                                Troubleshooting for network problems requires lots of
                                <br>
                                knowledge, which is too difficult for
                                IT.
                            </p>
                        </div>
                    </li>
                </ul>
            </div>
        </div>
    <div class="index_02">
            <div class="wrap">
                <div class="clearfix">
                    <div class="pull-left">
                        <h2 class="fnt_32 wow fadeInUp animated animated" style="visibility: visible;">Why ACN solution is important to me?</h2>
                        <p class="fnt_16 wow fadeInUp animated animated" style="visibility: visible; animation-name: fadeInUp;">
                            Nowadays, business expansion is common. The multi-service data
                            <br>
                            needs to run orderly
                            in the network, but it takes a lot of resources, visible
                            <br>
                            or invisible. Auto-configured Network
                            Solution is designed to solve this
                            <br>
                            problem.
                        </p>
                        <ul class="wow fadeInUp pcleftul leftul clearfix animated animated" style="visibility: visible; animation-name: fadeInUp;">
                            <li class="">
                                <div class="imgbox">
                                    <img src="https://www.ruijienetworks.com/solutions/smb/auto-configured-Network-Solution/image/2icon1.png" alt="">
                                </div>
                                <h2 class="fnt_16">
                                    Simplify
                                    <br>
                                    Configuration
                                </h2>
                                <p>
                                    Configure a multi-VLAN
                                    <br>
                                    enterprise network with around
                                    <br>
                                    100 switches and Access points
                                    <br>
                                    in a coffee break
                                </p>
                            </li>
                            <li class="">
                                <div class="imgbox">
                                          <img src="https://www.ruijienetworks.com/solutions/smb/auto-configured-Network-Solution/image/2icon1.png" alt="">
                                </div>
                                <h2 class="fnt_16">
                                    Visible
                                    <br>
                                    VLANs
                                </h2>
                                <p>
                                    IT can know the VLAN list and
                                    <br>
                                    traffic on the network without
                                    <br>
                                    complicated operations
                                </p>
                            </li>
                            <li class="">
                                <div class="imgbox">
                                          <img src="https://www.ruijienetworks.com/solutions/smb/auto-configured-Network-Solution/image/2icon1.png" alt="">
                                </div>
                                <h2 class="fnt_16">
                                    Automatic
                                    <br>
                                    Troubleshooting
                                </h2>
                                <p>
                                    Automatically detect VLAN-
                                    <br>
                                    related faults and provides one-
                                    <br>
                                    click troubleshooting solutions
                                </p>
                            </li>
                        </ul>

                    </div>
                    <div class="pull-right wow fadeInRight animated animated" style="visibility: visible; animation-name: fadeInRight;">
                        <img src="https://www.ruijienetworks.com/solutions/smb/auto-configured-Network-Solution/image/rightbg.png" alt="">
                    </div>

                </div>
                <!-- 手机端显示 -->
                <ul class="wow fadeInUp phoneleftul leftul clearfix animated animated" style="visibility: visible;">
                    <li class="">
                        <div class="imgbox">
                            <img src="https://www.ruijienetworks.com/solutions/smb/auto-configured-Network-Solution/image/2icon1.png" alt="">
                        </div>
                        <h2 class="fnt_16">
                            Simplify
                            <br>
                            Configuration
                        </h2>
                        <p>
                            Configure a multi-VLAN
                            <br>
                            enterprise network with around
                            <br>
                            100 switches and Access points
                            <br>
                            in a coffee break
                        </p>
                    </li>
                    <li class="">
                        <div class="imgbox">
                            <img src="https://www.ruijienetworks.com/solutions/smb/auto-configured-Network-Solution/image/2icon1.png" alt="">
                        </div>
                        <h2 class="fnt_16">
                            Visible
                            <br>
                            VLANs
                        </h2>
                        <p>
                            IT can know the VLAN list and
                            <br>
                            traffic on the network without
                            <br>
                            complicated operations
                        </p>
                    </li>
                    <li class="">
                        <div class="imgbox">
                            <img src="https://www.ruijienetworks.com/solutions/smb/auto-configured-Network-Solution/image/2icon1.png" alt="">
                        </div>
                        <h2 class="fnt_16">
                            Automatic
                            <br>
                            Troubleshooting
                        </h2>
                        <p>
                            Automatically detect VLAN-
                            <br>
                            related faults and provides one-
                            <br>
                            click troubleshooting solutions
                        </p>
                    </li>
                </ul>
            </div>
        </div>
    <div class="index_03">
            <div class="wrap">
                <div class="title wow fadeInUp fnt_32 animated animated" style="visibility: visible; animation-name: fadeInUp;">
                    What is an Auto-configured Network(ACN) Solution
                </div>
                <div class="wow fadeInUp fnt_20 video_button index_03btn animated animated"  style="visibility: visible; animation-name: fadeInUp;" @click="showVideo">
                    <img src="https://www.ruijienetworks.com/solutions/smb/auto-configured-Network-Solution/image/vector1.png" alt="">
                    Learn more
                </div>
                <div class="tapwrap wow fadeInUp clearfix animated animated" style="visibility: visible; animation-name: fadeInUp;">
                    <ul class="pull-left clearfix">
                        <li class="clearfix" :class="{on: videoIndex === 0}" @click="changeIndex(0)">
                            <h2 class="fnt_18">Network Planning</h2>
                            <div class="leftbox">
                                <p>• Configure VLAN on all devices in a wizard</p>
                                <p>• DHCP server and clients applied automatically</p>
                            </div>
                            <div class="rightboximg">
                                <img src="https://www.ruijienetworks.com/solutions/smb/auto-configured-Network-Solution/image/tap1.png" alt="">
                            </div>
                        </li>
                        <li class="clearfix" :class="{on: videoIndex === 1}" @click="changeIndex(1)">
                            <h2 class="fnt_18">VLAN Visualization</h2>
                            <div class="leftbox">
                                <p>• Listing VLAN table on the network</p>
                                <p>• VLAN Traffic Visualized</p>
                            </div>
                            <div class="rightboximg">
                                <img src="https://www.ruijienetworks.com/solutions/smb/./auto-configured-Network-Solution/image/tap2.png" alt="">
                            </div>
                        </li>
                        <li class="clearfix" :class="{on: videoIndex === 2}" @click="changeIndex(2)">
                            <h2 class="fnt_18">Automated ACL</h2>

                            <div class="leftbox">
                                <p>• Drag the subnet to isolate users </p>
                                <p>
                                    • Automation ensures network security
                                </p>
                            </div>
                            <div class="rightboximg">
                                <img src="https://www.ruijienetworks.com/solutions/smb/auto-configured-Network-Solution/image/tap3.png" alt="">
                            </div>
                        </li>
                        <li class="clearfix" :class="{on: videoIndex === 3}" @click="changeIndex(3)">
                            <h2 class="fnt_18">VLAN Troubleshooting</h2>
                            <div class="leftbox">
                                <p>• Give a workaround automatic</p>
                                <p>• One-click network problem fixing</p>
                            </div>
                            <div class="rightboximg">
                                <img src="https://www.ruijienetworks.com/solutions/smb/auto-configured-Network-Solution/image/tap4.png" alt="">
                            </div>
                        </li>
                    </ul>
                    <div class="rightbox" :class="{on: videoIndex === 0}" >
                        <p>• Configure VLAN on all devices in a wizard</p>
                        <p>• DHCP server and clients applied automatically</p>
                        <video controls="" src="https://www.ruijienetworks.com/solutions/smb/auto-configured-Network-Solution/video/VLANNetworkPlanning.mp4"></video>
                    </div>
                    <div class="rightbox" :class="{on: videoIndex === 1}" >
                        <p>• Listing VLAN table on the network</p>
                        <p>• VLAN Traffic Visualized</p>
                        <video controls="" src="https://www.ruijienetworks.com/solutions/smb/auto-configured-Network-Solution/video/VLANVisualization.mp4"></video>
                    </div>
                    <div class="rightbox" :class="{on: videoIndex === 2}" >
                        <p>• Drag the subnet to isolate users </p>
                        <p>
                            • Automation ensures network security
                        </p>
                        <video controls="" src="https://www.ruijienetworks.com/solutions/smb/auto-configured-Network-Solution/video/AutomatedACL.mp4"></video>
                    </div>
                    <div class="rightbox" :class="{on: videoIndex === 3}" >
                        <p>• Give a workaround automatic</p>
                        <p>• One-click network problem fixing</p>
                        <video controls="" src="https://www.ruijienetworks.com/solutions/smb/auto-configured-Network-Solution/video/VLANTroubleshooting.mp4"></video>
                    </div>

                </div>
            </div>
        </div>
  </div>
</template>

<script>

export default {
  name: "ASN",
  components: {
  },
  data(){
    return {
        video_show:false,
        videoIndex:0
    }
  },
  methods:{
    showVideo(){
        this.video_show = true
    },
    closeVideo(){
        console.log(111);
         this.video_show = false
    },changeIndex(index){
        this.videoIndex = index
    }
  }
};
</script>
<style scoped>
.pull-left {
  float: left;
}
.pull-right {
  float: right;
}
.clearfix:after {
  content: ".";
  display: block;
  clear: both;
  visibility: hidden;
  line-height: 0;
  height: 0;
  font-size: 0;
}
.clearfix {
  *zoom: 1;
}
.site_banner_text {
  width: 100%;
}
.site_banner_text .banner_le h2 {
  font-family: 'Avenir';
  font-weight: bold;
  color: #141D4B;
  margin-bottom: 0.5%;
}
.site_banner_text .banner_le p {
  color: #141D4B;
}
.site_banner_text .banner_le .bannerbtn {
  margin-top: 5%;
  cursor: pointer;
  color: #325078;
  text-align: center;
  line-height: 36px;
  width: 160px;
  border: 1px solid #286AD1;
  border-radius: 30px;
}
.site_banner_text .banner_le .bannerbtn i {
  margin-left: 10px;
}
.site_banner_text .banner_le .bannerbtn:hover {
  background: #286AD1;
  color: #fff;
}
.title {
  font-family: 'Arial';
  font-style: normal;
  font-weight: 700;
  text-align: center;
  color: #325078;
}
.index_01 {
  padding: 3.2% 0 5.5%;
  background: #E8F1FE;
}
.index_01 ul {
  margin-top: 2.5%;
}
.index_01 ul li {
  padding: 2%;
  padding-bottom: 1%;
  position: relative;
  background: linear-gradient(180deg, #E6F0FE 0%, #FEFFFF 100%);
  border: 2px solid #FFFFFF;
  box-shadow: 0px 4px 30px #D2D8E5;
  border-radius: 12px;
  width: 32%;
  margin-right: 2%;
}
.index_01 ul li img {
  position: relative;
  z-index: 2;
  display: block;
  margin: 0 auto;
}
.index_01 ul li h2 {
  margin-top: 5px;
  position: relative;
  z-index: 2;
  font-family: 'Arial';
  font-style: normal;
  font-weight: 700;
  text-align: center;
  color: #19314F;
}
.index_01 ul li p {
  margin-top: 10px;
  height: 6em;
  position: relative;
  z-index: 2;
  font-family: 'Arial';
  font-style: normal;
  font-weight: 400;
  line-height: 1.5;
  text-align: center;
  color: #526B8A;
}
.index_01 ul li:nth-child(1n)::after {
  line-height: 1;
  font-weight: bold;
  font-size: 240px;
  content: '01';
  color: #fff;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}
.index_01 ul li:nth-child(2n)::after {
  line-height: 1;
  font-weight: bold;
  font-size: 240px;
  content: '02';
  color: #fff;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}
.index_01 ul li:nth-child(3n) {
  margin-right: 0;
}
.index_01 ul li:nth-child(3n)::after {
  line-height: 1;
  font-weight: bold;
  font-size: 240px;
  content: '03';
  color: #fff;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}
.index_02 {
  padding: 3.2% 0;
}
.index_02 > .wrap .clearfix > .pull-left {
  width: 60%;
}
.index_02 > .wrap .clearfix > .pull-left > h2 {
  font-family: 'Arial';
  font-style: normal;
  font-weight: 700;
  line-height: 1;
  margin-bottom: 20px;
  color: #325078;
}
.index_02 > .wrap .clearfix > .pull-left > p {
  margin-bottom: 18px;
  height: 6em;
  font-family: 'Arial';
  font-style: normal;
  font-weight: 400;
  line-height: 150%;
  /* or 24px */
  color: #526B8A;
}
.index_02 > .wrap .clearfix > .pull-right {
  width: 39%;
}
.index_02 > .wrap .clearfix > .pull-right img {
  width: 100%;
}
.leftul > li {
  text-align: left;
  float: left;
  width: 33.33%;
}
.leftul > li .imgbox {
  margin-bottom: 14px;
  position: relative;
  display: inline-block;
  width: 64px;
  height: 64px;
  background: #EFF6FF;
  border-radius: 50px;
}
.leftul > li .imgbox img {
  position: absolute;
  top: 50%;
  left: 50%;
  max-width: 100%;
  transform: translate(-50%, -50%);
}
.leftul > li h2 {
  margin-bottom: 16px;
  font-family: 'Arial';
  font-style: normal;
  font-weight: 700;
  line-height: 18px;
  text-align: left !important;
  color: #19314F;
}
.leftul > li p {
  font-family: 'Arial';
  font-style: normal;
  font-weight: 400;
  line-height: 150%;
  height: 6em;
  text-align: left !important;
  color: #526B8A;
}
.phoneleftul {
  display: none;
}
.index_03 {
  padding: 3.2% 0;
  background: #E8F1FE;
}
.index_03 .index_03btn {
  font-weight: bold;
  line-height: 48px;
  color: #286AD1;
  cursor: pointer;
  text-align: center;
  margin: 0 auto;
  width: 200px;
  background: linear-gradient(182.97deg, #F4F6FB 15.08%, #CAE1FC 94.71%);
  border: 2px solid #FFFFFF;
  box-shadow: 0px 4px 30px #D2D8E5;
  border-radius: 40px;
  margin-top: 24px;
  margin-bottom: 40px;
}
.index_03 .index_03btn img {
  margin-right: 10px;
  display: inline-block;
}
.index_03 .tapwrap {
  overflow: hidden;
  position: relative;
  border-radius: 20px;
}
.index_03 .tapwrap ul {
  width: 40%;
}
.index_03 .tapwrap ul li {
  cursor: pointer;
  padding: 16px 24px;
  border-top: 4px solid #fff;
  background: linear-gradient(268.3deg, #C9E1FF 3.78%, #F7F8FC 94.94%);
}
.index_03 .tapwrap ul li h2 {
  margin-bottom: 16px;
  padding-left: 10px;
  position: relative;
  font-family: 'Arial';
  font-style: normal;
  font-weight: 700;
  line-height: 21px;
  color: #19314F;
}
.index_03 .tapwrap ul li h2::after {
  content: '';
  position: absolute;
  width: 4px;
  height: 20px;
  background: linear-gradient(180deg, #0E83FE 0%, #32B1FE 100%);
  box-shadow: 0px 0px 8px #D2D8E5;
  border-radius: 10px;
  left: 0;
}
.index_03 .tapwrap ul li .leftbox {
  height: 3em;
  float: left;
  width: 70%;
}
.index_03 .tapwrap ul li .leftbox p {
  font-family: 'Arial';
  font-style: normal;
  font-weight: 400;
  color: #526B8A;
  line-height: 1.5em;
}
.index_03 .tapwrap ul li .rightboximg {
  float: right;
  width: 30%;
}
.index_03 .tapwrap ul li .rightboximg img {
  width: 100%;
  max-width: 100%;
  display: none;
}
.index_03 .tapwrap ul li.on {
  /* min-height: 163px; */
  max-height: 163px;
  position: relative;
  border: none;
  background: linear-gradient(180deg, #0C81FD 0%, #33B2FD 100%);
}
.index_03 .tapwrap ul li.on::before {
  /* background: url(../images/jian.png) no-repeat; */
  position: absolute;
  content: '';
  z-index: 99;
  width: 14px;
  height: 21px;
  right: -14px;
  top: 50%;
}
.index_03 .tapwrap ul li.on h2 {
  font-family: 'Arial';
  font-style: normal;
  font-weight: 700;
  line-height: 21px;
  color: #FFFFFF;
}
.index_03 .tapwrap ul li.on h2::after {
  content: '';
  background: linear-gradient(360deg, #FEFFFF 5%, #CFDCEF 97.5%);
}
.index_03 .tapwrap ul li.on .leftbox p {
  font-family: 'Arial';
  font-style: normal;
  font-weight: 400;
  color: #FFFFFF;
}
.index_03 .tapwrap ul li.on .rightboximg img {
  display: block;
}
.index_03 .tapwrap .rightbox {
  display: none;
  position: relative;
  right: 0;
  top: 0;
  height: 100%;
  position: absolute;
  width: 60%;
  background: linear-gradient(180deg, #1288FE 0%, #30AEFE 100%);
}
.index_03 .tapwrap .rightbox > p {
  display: none;
  font-family: 'Arial';
  font-style: normal;
  font-weight: 400;
  line-height: 150%;
  color: #FFFFFF;
}
.index_03 .tapwrap .rightbox.on {
  display: block;
}
.index_03 .tapwrap .rightbox video {
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  position: absolute;
  display: block;
  margin: 0 auto;
  max-width: 80%;
}
.index_04 {
  background: linear-gradient(180deg, #0A73FC 0%, #34A7FB 100%);
  padding: 4% 0;
}
.index_04 .wrap .title {
  color: #fff;
}
.index_04 .wrap .swiperbox {
  /* margin: 10px -20px; */
}
.index_04 .wrap .swiperbox .swiper-container {
  padding: 50px 20px;
}
@media only screen and (min-width: 1025px){
  .index_03 .tapwrap ul li.on {
    min-height: 163px;
  }
  .index_04 .wrap .swiperbox .swiper-slide {
    width: 23%;
    margin-right: 2.66%;
    display: block !important;
  }
}
.index_04 .wrap .swiperbox .swiper-slide {


  transition: all 0.5s;
  min-height: 520px;
  padding: 20px;
  background: linear-gradient(180deg, #E6F0FE 0%, #FEFFFF 100%);
  border: 2px solid #FFFFFF;
  box-shadow: 0px 4px 30px #286AD1;
  border-radius: 12px;
  box-sizing: border-box;
}
.index_04 .wrap .swiperbox .swiper-slide:nth-child(4n){
  margin-right: 0;
}
.index_04 .wrap .swiperbox .swiper-slide .topimg {
  width: 100%;
  padding-bottom: 10px;
  border-bottom: 1px solid #325078;
}
.index_04 .wrap .swiperbox .swiper-slide .topimg img {
  width: 100%;
}
.index_04 .wrap .swiperbox .swiper-slide h2 {
  line-height: 1.2;
  height: 1.2em;
  margin-bottom: 16px;
  margin-top: 8px;
  font-family: 'Arial';
  font-style: normal;
  font-weight: 700;
  color: #325078;
}
.index_04 .wrap .swiperbox .swiper-slide h3 {
  font-family: 'Arial';
  font-style: normal;
  font-weight: 700;
  line-height: 150%;
  color: #19314F;
  height: 6em;
}
.index_04 .wrap .swiperbox .swiper-slide .pbox {
  margin-bottom: 5px;
  height: 12em;
}
.index_04 .wrap .swiperbox .swiper-slide .pbox p {
  font-family: 'Arial';
  font-style: normal;
  line-height: 150%;
  color: #526B8A;
}
.index_04 .wrap .swiperbox .swiper-slide .btnbottm i {
  transform: translateY(-20px);
  font-family: 'Arial';
  font-style: normal;
  font-weight: 700;
  color: #0274FC;
}
.index_04 .wrap .swiperbox .swiper-slide .btnbottm i:nth-child(2n) {
  margin-left: 20px;
  display: inline-block;
  font-weight: normal;
  transform: translateY(10px);
}
.index_04 .wrap .swiperbox .swiper-slide:hover {
  transform: scale(1.1, 1.1);
}
.index_04 .wrap .swiperbox .swiper-slide:hover h2 {
  color: #0274FC;
}
.bannerbtn:hover {
  background: #0274FC;
  color: #fff !important;
}
.index_05 {
  padding: 4% 0;
}
.index_05 .swiper-container {
  width: 90%;
}
.index_05 .wrap .swiper_05box {
  position: relative;
  margin-top: 36px;
}
.index_05 .wrap .swiper_05box .swiper-button-next,
.index_05 .wrap .swiper_05box .swiper-button-prev {
  width: 40px;
  height: 40px;
  border-radius: 50px;
  background: #EEF1FA;
}
.index_05 .wrap .swiper_05box .swiper-button-next img,
.index_05 .wrap .swiper_05box .swiper-button-prev img {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}
.index_05 .wrap .swiper-slide {
  position: relative;
  /* width: 100% !important;
  max-width: 80%; */
  overflow: hidden;
  border-radius: 20px;
}
.index_05 .wrap .swiper-slide a{
  width: 100%;
}
.index_05 .wrap .swiper-slide .pull-left {
  border-radius: 20px;
  overflow: hidden;
  width: 43%;
}
.index_05 .wrap .swiper-slide .pull-left img {
  width: 100%;
}
.index_05 .wrap .swiper-slide .rightabosl {
  position: relative;
  box-sizing: border-box;
  padding: 48px 35px;
  width: 55.2%;
  position: absolute;
  right: 0;
  top: 0;
  height: 100%;
  background: #E8F1FE;
  border-radius: 20px;
}
.index_05 .wrap .swiper-slide .rightabosl h2 {
  font-family: 'Arial';
  font-style: normal;
  font-weight: 700;
  color: #19314F;
}
.index_05 .wrap .swiper-slide .rightabosl p {
  margin-top: 16px;
  margin-bottom: 24px;
  font-family: 'Arial';
  font-style: normal;
  font-weight: 400;
  font-size: 12px;
  line-height: 150%;
  color: #526B8A;
}
.index_05 .wrap .swiper-slide .rightabosl ul li {
  font-family: 'Arial';
  font-style: normal;
  line-height: 150%;
  color: #19314F;
}
.index_05 .wrap .swiper-slide .rightabosl ul li i {
  font-weight: bold;
}
.index_05 .wrap .swiper-slide .rightabosl .bannerbtn {
  position: absolute;
  cursor: pointer;
  color: #325078;
  text-align: center;
  line-height: 36px;
  width: 160px;
  border: 1px solid #286AD1;
  border-radius: 30px;
  bottom: 20px;
}
.swiper-pagination {
  display: none;
}
@media only screen and (max-width: 767px) {
  .site_banner .banner_le {
    text-align: center;
  }
  .site_banner_text .banner_le p {
    text-align: center;
  }
  .site_banner_text .banner_le h2 {
    text-align: center;
  }
  .site_banner_text .banner_le .bannerbtn {
    margin: 0 auto;
    margin-top: 3%;
  }
  .index_01 ul li {
    margin-bottom: 24px;
    width: 100%;
  }
  .index_01 ul li img {
    float: left;
    width: 80px;
  }
  .index_01 ul li > div {
    float: right;
    width: calc(100% - 100px);
  }
  .index_01 ul li > div br {
    display: none;
  }
  .index_01 ul li > div h2,
  .index_01 ul li > div p {
    text-align: left;
  }
  .index_01 ul li::after {
    font-size: 115px !important;
    top: 50%;
    left: auto !important;
    right: 20px !important;
    transform: translate(0, -50%) !important;
  }
  .pcleftul {
    display: none;
  }
  .phoneleftul {
    display: block;
  }
  .index_02 > .wrap .clearfix > .pull-left > p {
    margin-bottom: 18px;
    height: auto;
    font-family: 'Arial';
    font-style: normal;
    font-weight: 400;
    line-height: 150%;
    color: #526B8A;
  }
  .index_02 > .wrap .clearfix > .pull-left > p br {
    display: none;
  }
  .index_02 > .wrap .clearfix > .pull-left > h2 {
    margin-bottom: 10px;
  }
  .leftul > li p {
    font-family: 'Arial';
    font-style: normal;
    font-weight: 400;
    line-height: 150%;
    height: auto;
    text-align: left !important;
    color: #526B8A;
  }
  .leftul > li p br {
    display: none;
  }
  .index_03 .tapwrap ul {
    float: none;
    width: 100%;
  }
  .index_03 .tapwrap ul li {
    border-top: none;
    border-right: 4px solid rgba(255, 255, 255, 0);
    min-height: 120px;
    padding: 20px 10px;
    width: 19%;
    float: left;
  }
  .index_03 .tapwrap ul li .leftbox {
    display: none;
  }
  .index_03 .tapwrap ul li .rightboximg {
    display: none;
  }
  .index_03 .tapwrap ul li h2 {
    margin-bottom: 0;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;
    line-height: 1.5;
    max-height: 6em;
    height: 6em;
    overflow: hidden;
    padding: 0;
    padding-top: 10px;
    width: 100%;
  }
  .index_03 .tapwrap ul li h2::after {
    content: '';
    position: absolute;
    width: 20px;
    height: 4px;
    background: linear-gradient(180deg, #0E83FE 0%, #32B1FE 100%);
    box-shadow: 0px 0px 8px #D2D8E5;
    border-radius: 10px;
    left: 0px;
    top: 00px;
  }
  .index_03 .tapwrap ul li.on {
    width: calc(100% - 19% * 3);
  }
  .index_03 .tapwrap ul li.on h2 {
    -webkit-line-clamp: 4;
    height: 12em;
    width: 60%;
  }
  .index_03 .tapwrap ul li.on::after {
    content: '';
    position: absolute;
    width: 20px;
    height: 4px;
    background: linear-gradient(360deg, #FEFFFF 5%, #CFDCEF 97.5%);
    box-shadow: 0px 0px 8px #D2D8E5;
    border-radius: 10px;
    left: 0px;
    top: 0;
  }
  .index_03 .tapwrap ul li:nth-child(4n) {
    border: none;
  }
  .index_03 .tapwrap .rightbox {
    display: none;
    position: relative;
    right: 0;
    top: 0;
    height: 100%;
    position: static;
    width: 100%;
    background: linear-gradient(180deg, #1288FE 0%, #30AEFE 100%);
  }
  .index_03 .tapwrap .rightbox > p {
    display: block;
    font-family: 'Arial';
    font-style: normal;
    font-weight: 400;
    line-height: 150%;
    color: #FFFFFF;
  }
  .index_03 .tapwrap .rightbox {
    padding: 20px;
  }
  .index_03 .tapwrap .rightbox video {
    position: static;
    width: 100%;
    max-width: 100%;
    margin-top: 10px;
    transform: none;
  }
  .index_04 .wrap .swiperbox .swiper-container {
    padding: 0;
    /* overflow: unset; */
  }
  .index_04 .wrap .swiperbox .swiper-slide{
    box-shadow: none;
    height: auto !important;
  }
  .index_04 .wrap .swiperbox .swiper-slide a {
    display: block;
  }
  .index_04 .wrap .swiperbox .swiper-slide:hover {
    transform: scale(1, 1);
  }
  .swiperbox {
    margin-top: 15px;
  }
  .index_04 .wrap .swiperbox .swiper-slide .topimg {
    width: 100%;
    padding-bottom: 0;
    border-bottom: none;
  }
  .index_04 .wrap .swiperbox .swiper-slide {
    padding: 10px;
  }
  .index_04 .wrap .swiperbox .swiper-slide h2 {
    margin-bottom: 5px;
    margin-top: 8px;
  }
 
  .index_04 .wrap .swiperbox .swiper-slide .pbox {
    margin-bottom: 5px;
    height: auto;
  }
  .index_04 .wrap .swiperbox .swiper-slide .btnbottm {
    text-align: right;
  }
  .index_04 .wrap .swiperbox .swiper-slide .btnbottm i:nth-child(2n) {
    margin-left: 10px;
    display: inline-block;
    font-weight: normal;
    transform: translateY(5px);
  }
  .index_05 .swiper-container {
    width: 100%;
  }
  .index_05 .wrap .swiper-slide .pull-left {
    border-radius: 20px;
    overflow: hidden;
    width: 80%;
  }
  .index_05 .wrap .swiper-slide .rightabosl {
    padding: 20px 15px;
    width: 70%;
    border-radius: 0px;
  }
  .index_05 .wrap .swiper-slide .rightabosl .bannerbtn {
    display: none;
  }
  .index_05 .wrap .swiper-slide .rightabosl p {
    margin-top: 5px;
    margin-bottom: 10px;
  }
  .index_05 .wrap .swiper_05box .swiper-button-next,
  .index_05 .wrap .swiper_05box .swiper-button-prev {
    display: none;
  }
  .swiper-pagination-bullet-active {
    opacity: 1 !important;
  }
  .index_05 .swiper-pagination-bullet {
    background: #FFFFFF !important;
    opacity: 0.5;
  }
  .swiper-pagination {
    display: block !important;
  }
  .index_03 .tapwrap ul li {
    padding-bottom: 10px;
    min-height: auto    ;
  }
  .index_03 .tapwrap ul li h2 {
    height: auto;
  }
  .index_03 .tapwrap ul li.on h2 {
    height: auto;
  }
  .index_03 .tapwrap ul li.on::before {
    /* background: url(../images/22222222.png) no-repeat; */
    position: absolute;
    content: '';
    z-index: 99;
    width: 21px;
    height: 14px;
    right: 50%;
    top: auto;
    bottom: -14px;
    transform: translateX(50%);
  }
  .index_03 .index_03btn {
    font-weight: bold;
    line-height: 48px;
    color: #286AD1;
    cursor: pointer;
    text-align: center;
    margin: 0 auto;
    width: 200px;
    background: linear-gradient(182.97deg, #F4F6FB 15.08%, #CAE1FC 94.71%);
    border: 2px solid #FFFFFF;
    box-shadow: 0px 4px 30px #D2D8E5;
    border-radius: 40px;
    margin-top: 14px;
    margin-bottom: 25px;
  }
}
.fnt_48 {
    font-size: 48px;
}
@media only screen and (max-width: 1399px){
.fnt_48 {
    font-size: 36px;
}
.fnt_32 {
    font-size: 28px;
}
.fnt_18 {
    font-size: 16px;
}
}
@media only screen and (max-width: 1599px){

.fnt_32 {
    font-size: 30px;
}
.fnt_20 {
    font-size: 18px;
}
}
/* reset */

body, div, ul, ol, li, dl, dt, dd, h1, h2, h3, h4, h5, h6, iframe, pre, code, fieldset, legend, form, input, select, textarea, button, p, blockquote, th, td, figure { margin: 0; padding: 0 }
body, div, ul, ol, li, dl, dt, dd, h1, h2, h3, h4, h5, h6, iframe, pre, code, fieldset, legend, form, p, blockquote, figure, header, footer, nav, article, section, aside, address, figcaption { *zoom: 1 }
li { list-style-type: none }
h1, h2, h3, h4, h5, h6 { font-size: 100%; font-weight: normal;}
iframe, frame, fieldset, img { border: 0 none }
img { vertical-align: top }
input[type=button], input[type=submit], input[type=reset] { cursor: pointer }
button { cursor: pointer }
input, textarea, button { -webkit-border-radius: 0; -webkit-appearance: none }
input[type=radio] { -webkit-border-radius: 100%; -webkit-appearance: radio }
input[type=checkbox] { -webkit-appearance: checkbox }
input[type=search] { -webkit-box-sizing: content-box; -moz-box-sizing: content-box; -ms-box-sizing: content-box; -o-box-sizing: content-box; box-sizing: content-box }

textarea { overflow: auto; resize: none }
::-webkit-input-placeholder{color:#BDBDBD;}   
:-moz-placeholder{color:#BDBDBD;}          
::-moz-placeholder{color:#BDBDBD;}            
:-ms-input-placeholder{color:#BDBDBD; opacity: 0.8;}        
.placeholder{color:#BDBDBD;}

blockquote, q { quotes: none }
blockquote:before, blockquote:after, q:before, q:after { content: ""; content: none }
table { border-collapse: collapse; border-spacing: 0 }
caption, th { text-align: left }
th { font-weight: normal }
em, cite, address,i { font-style: normal}
body, input, select, button, textarea {color:#272727; font-size: 14px; line-height: 1.5;font-family:Arial, Helvetica, sans-serif\;}
a { color:#272727;text-decoration: none!important;}
a { blr:expression(this.onFocus=this.blur())}
a * { *cursor: pointer }
:focus { outline: none }

a:link,
a:active,
a:visited,
a:hover {
    background: none;
    -webkit-tap-highlight-color: rgba(0,0,0,0);
    -webkit-tap-highlight-color: transparent;  
}

img{max-width: 100%;}
/* 阿里图标 */
[class*='icon']{
    font-family: 'iconfont';
}

*{outline:none!important;}
a:hover{outline:none!important;}
/*
@font-face { 
    font-family: SourceHanSansCN-Light;
    src: url('../font/SourceHanSansCN-Light.ttf') format('truetype');
}
@font-face { 
    font-family: SourceHanSansCN-Medium;
    src: url('../font/SourceHanSansCN-Medium.ttf') format('truetype');
} 
@font-face { 
    font-family: SourceHanSansCN-Regular;
    src:url('../font/SourceHanSansCN-Regular.ttf') format('truetype');
} 
body, input, select, button, textarea{
    font-family: SourceHanSansCN-Regular; 
}*/

img {
    vertical-align: middle;
}
.edit_con_original{ line-height:1.8em; padding:0 0; color:#000000;}
.edit_con_original ul{ margin:inherit; padding:inherit; padding-left:2em;}
.edit_con_original ul li { list-style-type:disc; margin:auto; }
.edit_con_original ol{ margin:inherit; padding:inherit}
.edit_con_original ol li { list-style-type:decimal; margin:auto; }
.edit_con_original h1 { font-size: 2em; font-weight:bold }
.edit_con_original h2 { font-size: 1.5em; font-weight:bold }
.edit_con_original h3 { font-size: 1.17em; font-weight:bold }
.edit_con_original h4 { font-size: 1em; font-weight:bold }
.edit_con_original h5 { font-size: 0.83em; font-weight:bold }
.edit_con_original h6 { font-size: 0.67em; font-weight:bold }
.edit_con_original em { font-style: italic }
.edit_con_original cite{ font-style: italic }
.edit_con_original address{ font-style: italic }
.edit_con_original i { font-style: italic }
.edit_con_original table{ border-collapse: separate; border-spacing: 2px }
.edit_con_original img{ max-width:100%; height:auto;}
.edit_con_original video{max-width: 100%;}
/*所有后台编辑器区域都要引用 edit_con_original 类名*/

/* clear 页头，页脚，内容区都不用再加清除样式 */
.fixed:before, .clearfix:before, .cf:before, body:before, .header:before, .main:before, .footer:before { content: ''; display: table }
.fixed:after, .clearfix:after, .cf:after, after, .header:after, .main:after, .footer:after { content: ''; display: table; clear: both }
.fixed, .clearfix, .cf, .header, .main, .footer { *zoom: 1 }
.clear, .cl { display: block!important; float: none!important; clear: both; width: auto!important; max-width: none!important; min-width: 0!important; max-height: none!important; min-height: 0!important; overflow: hidden; margin: 0!important; padding: 0!important; border: 0 none!important; font-size: 0!important; line-height: 0!important }

/*两端对齐*/
.justify { text-align:justify; text-justify:distribute-all-lines;}

/*图片经过*/
.tran_scale{ overflow:hidden; display:block;}
.tran_scale img{transition:0.5s all; -webkit-transition:0.5s all;}

/*截字*/
.ellipsis{ overflow:hidden; text-overflow:ellipsis; white-space:nowrap; width:100%;}
.clamp{display:-webkit-box; -webkit-box-orient: vertical;-webkit-line-clamp: 2; line-height: 1.5; max-height: 3em;height: 3em;overflow:hidden;}
.clamp_3{display:-webkit-box; -webkit-box-orient: vertical;-webkit-line-clamp: 3; line-height: 1.5; max-height: 4.5em;height: 4.5em;overflow:hidden;}
.clamp_4{display:-webkit-box; -webkit-box-orient: vertical;-webkit-line-clamp: 4; line-height: 1.5;  max-height: 6em;height: 6em;overflow:hidden;}
.clamp_5{display:-webkit-box; -webkit-box-orient: vertical;-webkit-line-clamp: 5; line-height: 1.5;  max-height: 7.5em;height: 7.5em;overflow:hidden;}
.clamp_6{display:-webkit-box; -webkit-box-orient: vertical;-webkit-line-clamp: 6; line-height: 1.5;  max-height: 9em;height: 9em;overflow:hidden;}

/*上下居中*/
.v-m-c{ transform: translate(0,-50%); -webkit-transform: translate(0,-50%); -ms-transform: translate(0,-50%); position:absolute; left:0; top:50%;}

/*左右居中*/
.l-m-c{ transform: translate(-50%,0); -webkit-transform: translate(-50%,0); -ms-transform: translate(-50%,0);position:absolute; left:50%; top:0;}

/*绝对居中*/
.a-m-c{ transform: translate(-50%,-50%); -webkit-transform: translate(-50%,-50%); -ms-transform: translate(-50%,-50%); position:absolute; left:50%; top:50%;}

/*背景*/
.bg-cover{background-size: cover; background-repeat: no-repeat; background-position: center;}
.bg_layer{background: rgba(0,0,0,0.7); position: absolute; left:0; top:0; width: 100%; height: 100%; z-index: 10000;}
.bg-cover-ban{ background-size: 100% 100%;}

.ratio-img,.ratio-img img{width: 100%;}
*{box-sizing: border-box;}
.swiper-button-prev.swiper-button-disabled,.swiper-button-next.swiper-button-disabled{pointer-events:inherit!important;}


.wrap{max-width: 1200px; margin:0 auto; width:90%;}

.select-box{position: relative;}
.select-box dt{cursor: pointer;color:#000; position: relative;}
.select-box dt i{ position: absolute; right:0; top:0; widtH:60px; height: 100%; color:#0054ca; text-align: center;}
.select-box dt.on_o i{transform:rotate(180deg);-ms-transform:rotate(180deg);-webkit-transform:rotate(180deg);}
.select-box dd{display: none;padding:0;position: absolute; z-index: 10;left:0;top:50px; width:100%;background: #fff;max-height: 220px;overflow: auto;}
.select-box dd a{display: block;color:#4E5258;cursor: pointer; padding:0 20px;}



/*.user{ float: right; line-height: 36px; margin-left: 30px; position: relative;}*/
/*.user::before{ opacity: 0; content: ""; position: absolute; lefT:0px; top:25%; widtH:1px; height: 50%; background: #000;}*/
/*.user em{margin: 0 10px;}*/
.pc_menu{position: absolute;right: 0;top: 0;width: 77px;height: 77px;background: #0054ca;cursor: pointer;display: none;}
.lang{ float: left; margin:0 20px;}
.lang dt{ cursor: pointer; height:30px; line-height: 30px;}
.lang dt a{color: #fff;}
.lang dt i{font-size: 20px; margin-left:4px; font-weight: bold;}
.lang dd{ display: none; position: relative; z-index: 10; width: 100%; background: #0054ca; border-top:1px solid rgba(255,255,255,0.5); padding:10px;}
.lang dd a{ height:24px; line-height: 24px; display: block; color:#fff!important; text-align: center; }
.lang.on dd{ display: block;}



.indmain{padding-top: 77px;}
.index_body .nav ul>li>a{color: #fff;}
.index_body .lang a{color: #fff;}
.index_body .lang dt{color: #fff;}

.index_body.scroll-header header{background: rgba(0,0,0,0.6);}
/*视频弹出*/
.video_appbox{ position:fixed; width:100%; height:100%; top:0; left:0; z-index:9999999;opacity: 0;visibility: hidden;transition:all 0.6s;-webkit-transition:all 0.6s;-moz-transition:all 0.6s;-o-transition:all 0.6s;-ms-transition:all 0.6s;}
.video_appbox.show{visibility: visible;opacity:1;}
.video_appbox video{object-fit: cover;width: 100%;}
.video_appbox .video_t{z-index:12; background:#000;width: 1035px;max-width:94%;transform: translate(-50%,-50%); -webkit-transform: translate(-50%,-50%);-ms-transform: translate(-50%,-50%);-moz-transform: translate(-50%,-50%);-o-transform: translate(-50%,-50%); position:absolute; left:50%; top:60%;transition:all 0.6s;-webkit-transition:all 0.6s;-moz-transition:all 0.6s;-o-transition:all 0.6s;-ms-transition:all 0.6s;visibility: hidden;opacity: 0;}
.video_appbox.show .video_t{ visibility: visible;opacity:1;top:50%;}
.video_appbox iframe{width:100%; height: 100%;}
.video_appbox .mask{ position:absolute; z-index:4; left:0; top:0; width:100%; height:100%; background:rgba(0,0,0,0.5);}
.lt9 .video_appbox .mask{filter: progid:DXImageTransform.Microsoft.Gradient(GradientType=0, StartColorStr="#88000000", EndColorStr="#88000000");}
.vide0_close{ position:absolute; top:calc(15% - 60px); right:calc(50% - 517px); cursor:pointer; z-index: 99999;}
.vide0_close i{color: #fff;font-size:30px;font-weight: bold;}



@media only screen and (min-width: 1025px){
    .yes_tran,a,.nav,.header,.header .logo,.nav_all .ll li i{transition: 0.3s all;-webkit-transition: 0.3s all;-moz-transition: 0.3s all;-o-transition: 0.3s all;-ms-transition: 0.3s all;}
    a:hover{color: #0054ca!important;}
    .tran_scale:hover img{transform:scale(1.05,1.05); -webkit-transform:scale(1.05,1.05);}
    .nav ul>li:hover>a>em{opacity: 1; left:0;width:100%;}
}
@media only screen and (max-width: 1365px){
.nav ul>li{margin:0 0 0 3%;}
}
@media only screen and (max-width: 1279px){
.nav{ widtH:calc(100% - 220px);}
/*.user{margin-left: 10px;}*/
.nav ul{ widtH:calc(100% - 215px); font-size: 14px;}
.nav ul>li{margin-left: 2%;}

}

@media only screen and (max-width: 1024px){
    /* body>*{position: relative;left:0;transition:left 250ms ease-out;-webkit-transition:left 250ms ease-out;} */
    body, input, select, button, textarea{ font-size:14px;}
    .header{height:50px;background: #0054ca;}
    .header .logo{margin-top:8px;width: 93px;height: 34px;}
    .rr_top{widtH:100%; padding-top: 0; margin-top: 0;}
    /*.user{margin: 5px 20px 5px 0;}*/
    /*.user,.user a{color:#fff;}*/
    span.ser{display: none;}
    .search_wrap{widtH:calc(100% - 40px); margin:20px; display: block; position: static; height: 36px; line-height: 36px;}
    .search_box_text,.search_box_button{height: 36px; line-height: 36px;}
    .search_box_text{width: calc(100% - 40px);}
}

@media only screen and (max-width: 1023px){
   
}
@media only screen and (max-width: 767px){

    
}

/*内页banner*/
.site_banner_wrap{position:relative;}
.site_banner{position: relative;overflow: hidden;background-size: cover;}
.site_banner img{width: 100%;}
.site_banner .banner_le p{}
.blank_20{position: absolute;left: 0;top:0;width: 100%;height: 100%;background: rgba(0,0,0,0.2);}
.blank_33{position: absolute;left: 0;top:0;width: 100%;height: 100%;background: rgba(0,0,0,0.33);display: none;}
.banner_line{width: 90px;height: 5px;background: #fff;display: block;margin-top: 40px;}
@media only screen and (max-width:1024px) {
    .site_banner_wrap{margin-top: 0;}
}
@media only screen and (max-width:767px) {
    .site_banner{height: 200px;}
    .site_banner img{display:none;}
    .site_banner .banner_le{text-align: left;}
    .site_banner .banner_le h3{margin-bottom: 0px;}
    .banner_line{margin-top: 30px;}

}
/*内页banner end*/
@media only screen and (max-width:767px) {
.weixin{width:70%;}
}


.mCSB_scrollTools .mCSB_dragger .mCSB_dragger_bar,
.mCSB_scrollTools .mCSB_dragger.mCSB_dragger_onDrag .mCSB_dragger_bar{ background: #267E88!important;}



.law_wrap{
  padding: 5% 0;
}


</style>
